const SI_SYMBOLS = ['', 'k', 'M', 'B', 'T', 'Q', 'XZ', 'EX']

export function _siNumber(number: number, decimals?: number): string {
	if (decimals == undefined || decimals < 0) decimals = 1

	const tier = Math.floor(Math.log10(Math.abs(number)) / 3)

	if (tier <= 0) return '' + number

	// Shift the number space down 1450 -> 1.450 | 14500 -> 14.500 | 145000 -> 145.000 | 1450000 -> 1.450000
	const scaled = number / (Math.pow(10, tier * 3))

	// Round to a fixed decimal length.
	let formatted = Math.floor(scaled * Math.pow(10, decimals)) / Math.pow(10, decimals) + ''
	if (formatted.includes('.')) {
		// Remove trailing 0s (if necessary).
		while (formatted[formatted.length - 1] === '0') {
			formatted = formatted.substring(0, formatted.length - 1)
		}

		// Remove trailing decimal point (if necessary).
		if (formatted[formatted.length - 1] === '.') {
			formatted = formatted.substring(0, formatted.length - 1)
		}
	}

	return formatted + SI_SYMBOLS[tier]
}